<template>
  <div ref="columnWrapper" class="bids-add-bulk-column-chooser-columns">
    <div
      class="bids-add-bulk-column-chooser-columns__columns"
      :style="sliderStyles"
    >
      <div
        v-for="(column, index) in data"
        :key="column.title"
        class="bids-add-bulk-column-chooser-columns__column-wrapper"
        :style="columnStyle"
      >
        <BidsAddBulkColumnChooserColumn
          :is-selected="selectedColumn === index"
          :title="column.title"
          :items="column.items"
          @selected="setSelectedColumn(index)"
          @deSelected="deSelectColumn"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BidsAddBulkColumnChooserColumn from './BidsAddBulkColumnChooserColumn';

const MARGIN_BETWEEN_COLUMNS = 20; // in Pixel

export default {
  name: 'BidsAddBulkColumnChooserColumns',
  components: {
    BidsAddBulkColumnChooserColumn,
  },
  model: {
    prop: 'selectedColumn',
    event: 'selectedColumnChange',
  },
  props: {
    data: {
      required: true,
      type: Array,
    },
    perRow: {
      default: 4,
      type: Number,
    },
    currentSlide: {
      required: true,
      type: Number,
    },
    selectedColumn: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      columnsTotalWidth: 0,
      columnWidth: 0,
      isReady: false,
    };
  },
  computed: {
    columnsTotalWidthStyle() {
      const columnsCount = this.data.length;

      const totalColumnsWidth = this.columnWidth * columnsCount;
      const totalMarginsWidth = MARGIN_BETWEEN_COLUMNS * (columnsCount - 1);

      return totalColumnsWidth + totalMarginsWidth + 'px';
    },
    columnStyle() {
      return {
        width: this.columnWidth + 'px',
      };
    },
    eachSlideWidth() {
      return this.columnWidth + MARGIN_BETWEEN_COLUMNS;
    },
    sliderStyles() {
      return {
        width: this.columnsTotalWidthStyle,
        transform: `translateX(${this.currentSlide * this.eachSlideWidth}px)`,
      };
    },
  },
  mounted() {
    const slideWidth = this.$refs.columnWrapper.offsetWidth;

    this.columnWidth =
      (slideWidth - (this.perRow - 1) * MARGIN_BETWEEN_COLUMNS) / this.perRow;
  },
  methods: {
    setSelectedColumn(index) {
      this.$emit('selectedColumnChange', index);
    },
    deSelectColumn() {
      this.$emit('selectedColumnChange', -1);
    },
  },
};
</script>

<style lang="scss">
.bids-add-bulk-column-chooser-columns {
  overflow-x: hidden;
  width: 100%;

  &__columns {
    display: flex;
    justify-content: space-between;
    transition-property: transform;
    transition-duration: 0.5s;
  }
}
</style>
